var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "of-form-input" }, [
    !!_vm.label
      ? _c(
          "label",
          {
            staticClass: "block ml-1 mb-1 text-xs font-medium text-gray-900",
            attrs: { for: "email" }
          },
          [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "relative" }, [
      !!_vm.prependIcon
        ? _c(
            "div",
            {
              staticClass:
                "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
            },
            [
              _c("font-awesome-icon", {
                style: { color: "#a0a0a0" },
                attrs: { icon: ["fas", _vm.prependIcon] }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "input",
        _vm._b(
          {
            staticClass:
              "block bg-white border border-gray-200 text-gray-900 text-sm rounded-md block w-full p-1.5 placeholder:italic",
            class: {
              "border-red-500 focus:border-red-500 focus:ring-red-500": !!_vm.hasError,
              "ps-10": !!_vm.prependIcon
            },
            attrs: {
              type: _vm.inputType,
              id: _vm.inputName,
              name: _vm.inputName,
              disabled: _vm.submitting ? "disabled" : null,
              dusk: _vm.dusk,
              required: _vm.required,
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                _vm.$emit("input", $event.target.value)
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
    ]),
    _vm._v(" "),
    !!_vm.hasError
      ? _c("p", {
          staticClass: "my-2 text-xs text-red-500",
          domProps: { innerHTML: _vm._s(_vm.error) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48f9293e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f9293e","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formInput.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-48f9293e","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formInput.vue
// module chunks = 1 2 3